import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firestore } from '../../../config/firebase';
import axios from 'axios';
import { createSeller, fetchSellersList } from '../../../store/actions/sellerActions';
import Spinner from '../../UIComponents/Spinner';
import lang from '../lang';

class NewSeller extends Component {
    state = {
        name: '',
        email: '',
        phone: '',
        password: '',
        type: 'seller',
        display: 'none',
        createdAt: Date.now(),
        updatedAt: Date.now(),
        readOnly: false,
        active: false,
        msg: {
            msg: '',
            msgType: 'success',
            msgStatus: false,
            email: ''
        }
    }

    inputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            active: true
        })
    }

    submitHandler = (e) => {
        e.preventDefault();
        this.setState({ display: 'flex' });
        axios({
            method: 'post',
            url: '/users/new',
            data: {
                email: this.state.email,
                password: this.state.password,
                displayName: this.props.user.id
            }
        })
            .then(res => {
                if (res.data.success) {
                    const { msg, display, ...sellerData } = this.state;
                    firestore.collection('users')
                        .doc(this.props.user.id)
                        .collection('sellers')
                        .doc(res.data.uid)
                        .set({ ...sellerData })
                        .then(doc => {

                            this.setState({
                                msg: {
                                    ...this.state.msg,
                                    msgStatus: true,
                                    msgType: res.data.msgType,
                                    msg: res.data.msg[this.props.user.lang],
                                    email: '',
                                },
                                display: 'none',
                                readOnly: true
                            });

                            firestore.collection('sellers')
                                .doc(res.data.uid)
                                .set({
                                    ...sellerData,
                                    storeId: this.props.user.id,
                                    type: this.state.type,
                                    id: res.data.uid
                                });

                            this.props.createSeller({
                                ...sellerData,
                                storeId: this.props.user.id,
                                type: this.state.type,
                                id: res.data.uid
                            });
                            this.emailRef.className = 'form-control';

                        })
                } else {
                    this.setState({
                        msg: {
                            ...this.state.msg,
                            email: res.data.msg[this.props.user.lang],
                            msg: res.data.msg[this.props.user.lang],
                            msgStatus: true,
                            msgType: res.data.msgType
                        },
                        display: 'none'
                    });
                    if (!this.emailRef.className.includes('border-danger')) {
                        this.emailRef.className += ' border-danger';
                    }
                }
            })
            .catch(res => {
                this.setState({
                    msg: {
                        ...this.state.msg,
                        email: res.data.msg,
                        msg: res.data.msg[this.props.user.lang],
                        msgStatus: true,
                        msgType: res.data.msgType
                    },
                    display: 'none'
                });
            })
    }

    alertMessageHandler = () => {
        this.setState({ msg: { msgStatus: false } });
    }

    render() {
        const {
            add: {
                title,
                fullName,
                phone,
                chooseUser,
                manager,
                seller,
                email,
                password,
                btn,
                alert
            }
        } = lang[this.props.user.lang || 'uz'];
        if (this.props.sellers.length < 3 || this.state.active) {
            return (
                <div id="new-seller">
                    <Spinner display={this.state.display} />
                    <div
                        className={`alert alert-${this.state.msg.msgType} mb-5`}
                        style={{ display: this.state.msg.msgStatus ? 'block' : 'none' }}
                    >
                        <strong>{this.state.msg.msg}</strong>
                        <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <h3 className="text-center">{title}</h3>
                    <div className="row">
                        <form className="col-8 offset-2" onSubmit={(e) => this.submitHandler(e)} autoComplete="off">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    placeholder={fullName}
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="phone"
                                    className="form-control"
                                    placeholder={phone}
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                />
                            </div>
                            <div className="my-3 text-center">
                                <label htmlFor="user type" className="mr-3 text-warning">{chooseUser}</label>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        value="seller"
                                        name="type"
                                        checked={this.state.type === 'seller' ? true : false}
                                        onChange={this.inputHandler}
                                    />
                                    <label className="form-check-label">{seller}</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        value="manager"
                                        name="type"
                                        checked={this.state.type === 'manager' ? true : false}
                                        onChange={this.inputHandler}
                                    />
                                    <label className="form-check-label">{manager}</label>
                                </div>
                            </div>

                            <div className="form-group flex-column">
                                <input type="password" hidden name="password-hide" />
                                <input type="email" hidden name="email-hide" />
                                <input
                                    type="email"
                                    name="email"
                                    className="form-control"
                                    placeholder={email}
                                    ref={(ref) => this.emailRef = ref}
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                    autoComplete="new-password"
                                    required
                                />
                                <div className="text-danger">{this.state.msg.email}</div>
                            </div>
                            <div className="form-group">
                                <input type="password" hidden name="password-hide" />
                                <input type="email" hidden name="email-hide" />
                                <input
                                    type="password"
                                    name="password"
                                    placeholder={password}
                                    required
                                    minLength="6"
                                    className="form-control"
                                    onChange={(e) => this.inputHandler(e)}
                                    readOnly={this.state.readOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                            <div className="text-center">
                                {
                                    !this.state.readOnly ? <button className="btn btn-success">{btn}</button> : null
                                }
                            </div>
                        </form>
                    </div>

                </div>
            )
        } else {
            return (
                <div>
                    <div className="alert alert-warning">
                        <h3>{alert}</h3>
                    </div>
                </div>
            )
        }

    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        sellers: state.sellers.sellers
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createSeller: (data) => dispatch(createSeller(data)),
        fetchSellers: (data) => dispatch(fetchSellersList(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(NewSeller);